namespace $.$$ {
	$mol_style_define($bog_music_account, {
		flex: { direction: 'column' },
		width: '100%',
		boxSizing: 'border-box',
		padding: {
			top: '0.5rem',
			bottom: '0.5rem',
			left: '0.5rem',
			right: '0.5rem',
		},
		gap: '0.75rem',

		Font_row: {
			alignItems: 'center',
			flex: { wrap: 'wrap' },
			gap: '0.5rem',
			padding: { left: '0.25rem', right: '0.25rem' },
		},

		Font_label: {
			color: $mol_theme.shade,
		},

		Font_size: {
			flex: { direction: 'row', wrap: 'wrap' },
		},

		Sync_row: {
			alignItems: 'center',
			flex: { wrap: 'wrap' },
			gap: '0.5rem',
			padding: { left: '0.25rem', right: '0.25rem' },
		},

		Download_playlist: {
			gap: '0.375rem',
			alignItems: 'center',
		},

		Download_playlist_label: {
			font: { size: '0.875rem' },
		},

		Download_playlist_status: {
			font: { size: '0.8125rem' },
			color: $mol_theme.shade,
			flex: { grow: 1 },
		},

		Cards: {
			display: 'grid',
			gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 18rem), 1fr))',
			gap: '0.75rem',
			alignItems: 'start',
		},

		Profile: {
			flex: { direction: 'column' },
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			padding: {
				top: '0.75rem',
				bottom: '0.75rem',
				left: '0.75rem',
				right: '0.75rem',
			},
			gap: '0.5rem',
		},

		Lord: {
			font: {
				family: 'monospace',
				size: '0.875rem',
			},
			alignItems: 'baseline',
			padding: { top: '0.25rem', bottom: '0.25rem' },
			gap: '0.5rem',
		},

		// Идентификатор печатается целиком, поэтому строке нужно разрешить
		// перенос: без minWidth флекс-элемент не сжимается и вылезает за край.
		Lord_text: {
			minWidth: 0,
			overflowWrap: 'anywhere',
			userSelect: 'text',
		},

		Telegram: {
			flex: { direction: 'column' },
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			padding: {
				top: '0.75rem',
				bottom: '0.75rem',
				left: '0.75rem',
				right: '0.75rem',
			},
			gap: '0.5rem',
		},

		Tg_title: {
			font: { weight: 'bold' },
		},

		Tg_hint: {
			font: { size: '0.8125rem' },
			color: $mol_theme.shade,
		},

		Tg_status: {
			font: { size: '0.8125rem' },
			color: $mol_theme.shade,
			minHeight: '1rem',
		},

		Lastfm: {
			flex: { direction: 'column' },
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			padding: {
				top: '0.75rem',
				bottom: '0.75rem',
				left: '0.75rem',
				right: '0.75rem',
			},
			gap: '0.5rem',
		},

		Fm_title: {
			font: { weight: 'bold' },
		},

		Fm_hint: {
			font: { size: '0.8125rem' },
			color: $mol_theme.shade,
		},

		Fm_status: {
			font: { size: '0.8125rem' },
			color: $mol_theme.shade,
			minHeight: '1rem',
		},

		Export: {
			flex: { direction: 'column' },
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			padding: {
				top: '0.75rem',
				bottom: '0.75rem',
				left: '0.75rem',
				right: '0.75rem',
			},
			gap: '0.5rem',
		},

		Warning: {
			font: { size: '0.8125rem' },
			color: '#d33',
		},

		Copy_status: {
			font: { size: '0.8125rem' },
			color: $mol_theme.shade,
			minHeight: '1rem',
		},

		Qr: {
			width: '16rem',
			maxWidth: '100%',
			aspectRatio: 1,
			alignSelf: 'center',
			background: { color: 'white' },
			border: { radius: $mol_gap.round },
		},

		Import: {
			flex: { direction: 'column' },
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			padding: {
				top: '0.75rem',
				bottom: '0.75rem',
				left: '0.75rem',
				right: '0.75rem',
			},
			gap: '0.5rem',
		},

		Import_hint: {
			font: { size: '0.8125rem' },
			color: $mol_theme.shade,
		},

		Import_status: {
			font: { size: '0.8125rem' },
			color: $mol_theme.shade,
			minHeight: '1rem',
		},

		Reset: {
			flex: { direction: 'column' },
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			padding: {
				top: '0.75rem',
				bottom: '0.75rem',
				left: '0.75rem',
				right: '0.75rem',
			},
			gap: '0.5rem',
		},

		Reset_hint: {
			font: { size: '0.8125rem' },
			color: $mol_theme.shade,
		},
	})
}
